import Validator from 'validator';

const sanitize = (input: string): string => {
  return Validator.trim(input.toString());
};

const IsEmpty = (input?: string | null): boolean => {
  if (input === undefined || input === null) {
    return true;
  }

  return Validator.isEmpty(sanitize(input));
};

const IsGreaterThan = (min: number, input?: number | null): boolean => {
  if (input === undefined || input === null) {
    return false;
  }

  return input > min;
};

const IsNumeric = (input?: string | null): boolean => {
  if (input === undefined || input === null) {
    return false;
  }

  return Validator.isNumeric(sanitize(input));
};

const IsFraction = (input?: string | null): boolean => {
  if (input === undefined || input === null) {
    return false;
  }

  const sanitizedInput = sanitize(input);

  if (!sanitizedInput.includes('/')) {
    return false;
  }

  const [numerator, denominator] = sanitizedInput.split('/');

  return (
    Validator.isInt(sanitize(numerator)) &&
    Validator.isInt(sanitize(denominator))
  );
};

const IsNotEmpty = (input?: string | null): boolean => {
  if (input === undefined || input === null) {
    return false;
  }

  return !Validator.isEmpty(sanitize(input));
};

export { IsEmpty, IsGreaterThan, IsNotEmpty, IsNumeric, IsFraction };
